import { useCallback, useMemo } from 'react';

import { useAppDispatch } from '~/modules/store';
import { UIStateActions } from '~/modules/uiState/uiState.redux';
import analytics from '~/services/analytics';
import { ACTIONS } from '~/services/toasts/internalServerError';

import { testsApi } from '../../tests.api';
import { showStepError } from '../../tests.utils';
import { usePlaybackCursorPosition } from '../usePlaybackCursorPosition/usePlaybackCursorPosition';

export const useDuplicateStepInGroup = () => {
  const dispatch = useAppDispatch();
  const [duplicateStep, duplicateStepRequest] = testsApi.useDuplicateStepInGroupMutation();
  const { refreshPlaybackCursorPosition } = usePlaybackCursorPosition();

  const handleDuplicateStep = useCallback(
    async ({ stepId, groupId }: Parameters<typeof duplicateStep>[0]) => {
      analytics.trackEvent('step_duplicated');

      const result = duplicateStep({ stepId, groupId }).unwrap();

      result
        .then((duplicates) => {
          dispatch(
            UIStateActions.addRecentlyAddedStepsIds({
              stepsIds: duplicates.map((step) => step.id),
            }),
          );
          refreshPlaybackCursorPosition();
        })
        .catch((error) => {
          showStepError(ACTIONS.CLONE, error as Error);
        });

      return result;
    },
    [dispatch, duplicateStep, refreshPlaybackCursorPosition],
  );

  return useMemo(
    () => [handleDuplicateStep, duplicateStepRequest] as const,
    [handleDuplicateStep, duplicateStepRequest],
  );
};
